import { normalizeKawadernaLang, type KawadernaLang } from '~/composables/useKawadernaI18n'
import type { StoreLanguage } from '~/composables/useOnlineStores'

/**
 * Storefront language state shared by pages and the global storefront-locale
 * plugin. Kept apart from `useStorefrontLocale` (which re-exports these) so the
 * plugin does not drag `useOnlineStores` into every page's entry chunk.
 */

/**
 * Shared override so storefront pages keep one language across route changes.
 * Cleared only when leaving the storefront entirely (see storefront-locale
 * plugin) — which, on a store's own host, is never.
 */
export function useStorefrontLangOverride() {
  return useState<KawadernaLang | null>('storefront-lang-override', () => null)
}

/**
 * When true, the shopper/owner picked a language in the store UI — do not
 * overwrite it with the store's saved default on navigation.
 */
export function useStorefrontLangLocked() {
  return useState('storefront-lang-locked', () => false)
}

export function normalizeStoreLanguage(value: unknown): StoreLanguage {
  return normalizeKawadernaLang(value, 'ar')
}
